import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import {useViewportMediaQuery} from 'hooks'
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const ContentBlock = (props) => {
    const {image, url, title, paragraph, video_url, componentTitle, slot} = props

    const [isExpanded, setIsExpanded] = React.useState(false)
    const isMobile = useViewportMediaQuery(768)

    const gtmData = {
        id: image ? image.filename : video_url,
        name: componentTitle,
        creative: `Grilla 2/2 video o imagen`,
        position: `slot${slot}`,
        type: `gridTwoOverTwo`,
    }

    const promotionsClick = () => {
        TagManagerService.promotionsClick(gtmData)
    }

    const toggleParagraph = () => {
        setIsExpanded(!isExpanded)
    }

    const videoImageContent = () => (
        <>
            {image && (
                <div className="grid-two-over-two-block-aspect-ratio">
                    <ImageLoad src={image.url} alt={title} gtmData={gtmData} />
                </div>
            )}
            {video_url && (
                <div className="grid-two-over-two-block-aspect-ratio">
                    <iframe
                        src={`https://www.youtube.com/embed/${video_url}`}
                        frameBorder="0"
                        className="grid-two-over-two-block-video-iframe"
                        allow="encrypted-media"
                        allowFullScreen
                        title={title}
                    />
                </div>
            )}
        </>
    )

    return (
        <article className="grid-two-over-two-block">
            {url ? (
                <Link className="grid-two-over-two-link" to={url} onClick={promotionsClick}>
                    {videoImageContent()}
                </Link>
            ) : (
                <figure className="grid-two-over-two-link">
                    {videoImageContent()}
                </figure>
            )}
            {title && (
                <h1 className="grid-two-over-two-block-title">{title}</h1>
            )}
            {paragraph && (
                <p className={`grid-two-over-two-block-paragraph ${!isExpanded && isMobile && 'grid-two-over-two-block-paragraph-mobile'}`}>
                    {paragraph}
                    {' '}
                    {url && (
                        <Link className="grid-two-over-two-block-paragraph-link" to={url}>Ver más</Link>
                    )}
                </p>
            )}
            {paragraph && isMobile && (
                <button className="grid-two-over-two-block-paragraph-see-all" onClick={toggleParagraph}>
                    {isExpanded ? 'Ocultar' : 'Ver todo'}
                </button>
            )}
        </article>
    )
}

ContentBlock.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.shape({
            url: PropTypes.string,
        }),
        PropTypes.bool
    ]),
    url: PropTypes.string,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    video_url: PropTypes.string,
    componentTitle: PropTypes.string,
    slot: PropTypes.number,
}

export default ContentBlock
